import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChipButton, Row, Typography } from 'seagull';
import styles from './FollowUpSuggestions.module.scss';
export const FollowUpSuggestions = (param)=>{
    let { followUp, showSuggestions, biName, onSuggestionClick, testIds } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.followUp,
        "data-testid": testIds.FollowUp(),
        children: [
            followUp.text.length > 0 && /*#__PURE__*/ _jsx(Typography, {
                testId: testIds.FollowUpText(),
                children: followUp.text
            }),
            showSuggestions && followUp.suggestions.length > 0 && /*#__PURE__*/ _jsx(Row, {
                gap: 8,
                wrap: true,
                className: styles.suggestionChips,
                testId: testIds.FollowUpSuggestions(),
                children: followUp.suggestions.map((suggestion, idx)=>/*#__PURE__*/ _jsx(ChipButton, {
                        skin: "subtle",
                        testId: testIds.FollowUpSuggestion(idx),
                        bi: {
                            name: biName,
                            data: {
                                suggestionId: suggestion.id,
                                label: suggestion.label
                            }
                        },
                        disabled: onSuggestionClick == null,
                        onClick: onSuggestionClick != null ? ()=>onSuggestionClick(suggestion) : undefined,
                        children: suggestion.label
                    }, suggestion.id))
            })
        ]
    });
};
